import styled from 'styled-components';
import { getColor } from 'utils';

const StyledInviteForm = styled.div`
  .form-group {
    margin-bottom: 20px;

    .form-label {
      margin-bottom: 8px;
      font-weight: 600;
      font-size: 14px;
      color: ${getColor('text')()};
    }

    .state-badge {
      display: inline-flex;
      align-items: center;
      background: ${getColor('brand')()}15;
      color: ${getColor('brand')()};
      padding: 4px 8px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;
      margin-left: 8px;
      border: 1px solid ${getColor('brand')()}30;
      white-space: nowrap;
      min-width: fit-content;
      flex-shrink: 0;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: all 0.2s ease;
      cursor: pointer;

      &:hover {
        background: ${getColor('brand')()}25;
        border-color: ${getColor('brand')()}50;
      }
    }

    .state-badge-select {
      background: #6666ff !important;
      border: none !important;
      color: ${getColor('brand')()} !important;
      padding: 0 20px 0 4px !important;
      margin: 0 !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      cursor: pointer !important;
      appearance: none !important;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%236366f1' d='M5 7L1 3h8z'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right center !important;
      background-size: 10px !important;
      background-color: transparent !important;
      transition: all 0.2s ease !important;
      outline: none !important;
      min-width: 100px !important;
      max-width: 160px !important;
      height: auto !important;
      line-height: 1 !important;

      &:hover {
        opacity: 0.8;
      }

      &:focus {
        opacity: 1;
        background-color: transparent !important;
      }

      option {
        background: white;
        color: ${getColor('text')()};
        padding: 8px;
      }
    }

    .state-select-field {
      margin-bottom: 12px;
    }

    .state-select-wrapper {
      position: relative;
      display: inline-block;
      width: 100%;
      max-width: 200px;
    }

    .state-store-row {
      gap: 12px;
      margin-bottom: 16px;
    }

    .state-select-field {
      flex: 0 0 auto;
      width: auto;
      min-width: 180px;
    }

    .email-field-full {
      width: 100%;
    }

    .state-select {
      width: 100%;
      padding: 6px 32px 6px 12px;
      border: 1.5px solid ${getColor('border')()};
      border-radius: 8px;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.2s ease;
      background: ${getColor('white')()};
      font-family: inherit;
      color: ${getColor('text')()};
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236366f1' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 10px center;
      background-size: 12px;
      cursor: pointer;

      &:focus {
        outline: none;
        border-color: ${getColor('brand')()};
        box-shadow: 0 0 0 3px ${getColor('brand')()}15;
      }

      &:hover {
        border-color: ${getColor('brand')()}80;
      }

      &:disabled {
        background: ${getColor('grayClear')()};
        color: ${getColor('text')()}80;
        cursor: not-allowed;
        opacity: 0.6;
      }
    }

    .state-icon {
      margin-right: 6px;
      font-size: 14px;
      color: ${getColor('brand')()};
      flex-shrink: 0;
    }

    .form-select {
      width: 100%;
      padding: 12px 16px;
      border: 2px solid ${getColor('border')()};
      border-radius: 12px;
      font-size: 14px;
      transition: all 0.3s ease;
      background: ${getColor('white')()};
      font-family: inherit;

      &:focus {
        outline: none;
        border-color: ${getColor('brand')()};
        box-shadow: 0 0 0 3px ${getColor('brand')()}20;
      }

      &:disabled {
        background: ${getColor('grayClear')()};
        color: ${getColor('text')()};
        cursor: not-allowed;
      }

      &.error {
        border-color: ${getColor('error')()};
      }
    }

    /* Estilos para TextInput del sistema */
    > div {
      width: 100%;
    }

    /* Mejorar la apariencia de los campos */
    input, select {
      font-family: inherit;
      box-sizing: border-box;
    }

    .error-message {
      color: ${getColor('error')()};
      font-size: 12px;
      margin-top: 8px;
    }

    .help-text {
      color: ${getColor('text')()};
      font-size: 12px;
      margin-top: 8px;
      font-style: italic;
    }

    .radio-group {
      display: flex;
      gap: 12px;
      margin-top: 8px;
    }

    .radio-option {
      flex: 1;
      padding: 12px 14px;
      border-radius: 10px;
      transition: all 0.2s ease;
    }

    .radio-label {
      gap: 3px;
    }

    .form-row-compact {
      display: flex;
      gap: 12px;
      margin-bottom: 12px;
    }
  }

  .form-actions {
    margin-top: 40px;
    text-align: center;

    button {
      min-width: 200px;
      padding: 16px 32px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 12px;
      transition: all 0.3s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      &.loading {
        position: relative;
        color: transparent;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20px;
          height: 20px;
          border: 2px solid transparent;
          border-top: 2px solid ${getColor('white')()};
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
      }
    }
  }

  .form-info {
    margin-top: 32px;
    padding: 20px;
    background: ${getColor('grayClear')()};
    border-radius: 12px;
    border-left: 4px solid ${getColor('brand')()};
    word-wrap: break-word;
    overflow-wrap: break-word;

    p {
      margin: 0;
      line-height: 1.5;
      font-size: 14px;
    }
  }

  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }

  @media (max-width: 768px) {
    .form-actions {
      button {
        width: 100%;
        min-width: auto;
      }
    }
  }
`;

export default StyledInviteForm;
